import { render, staticRenderFns } from "./terraform_notification.vue?vue&type=template&id=50b2d1ba"
import script from "./terraform_notification.vue?vue&type=script&lang=js"
export * from "./terraform_notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports